import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "activeCaseNumber";
const CLEAR_EVENT = "canary:active-case-cleared";
const CaseContext = createContext({
  activeCaseNumber: "",
  setActiveCaseNumber: () => {},
});

export const clearStoredCaseNumber = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(CLEAR_EVENT));
};

export const CaseProvider = ({ children }) => {
  const [activeCaseNumber, setActiveCaseNumberState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "";
  });

  const setActiveCaseNumber = (nextValue) => {
    if (nextValue) {
      localStorage.setItem(STORAGE_KEY, nextValue);
      setActiveCaseNumberState(nextValue);
    } else {
      localStorage.removeItem(STORAGE_KEY);
      setActiveCaseNumberState("");
    }
  };

  // Ensure a stale case number from a previous session/user can't survive a
  // logout without a full page reload.
  useEffect(() => {
    const handleClear = () => setActiveCaseNumberState("");
    window.addEventListener(CLEAR_EVENT, handleClear);
    return () => window.removeEventListener(CLEAR_EVENT, handleClear);
  }, []);

  const value = useMemo(
    () => ({
      activeCaseNumber,
      setActiveCaseNumber,
    }),
    [activeCaseNumber]
  );

  return <CaseContext.Provider value={value}>{children}</CaseContext.Provider>;
};

export const useCase = () => useContext(CaseContext);
